import { FOREST_MARKET_LEVELS } from "./forest-market";
import { NUMBER_TRAIN_LEVELS } from "./number-train";
import { PATTERN_BRIDGE_LEVELS } from "./pattern-bridge";
import type { MathLevel } from "./types";

export { FOREST_MARKET_LEVELS } from "./forest-market";
export { NUMBER_TRAIN_LEVELS } from "./number-train";
export { PATTERN_BRIDGE_LEVELS } from "./pattern-bridge";
export type * from "./types";

export const MATH_LEVELS: readonly MathLevel[] = [
  ...NUMBER_TRAIN_LEVELS,
  ...FOREST_MARKET_LEVELS,
  ...PATTERN_BRIDGE_LEVELS
];
